/// <reference path="../../adonisrc.ts" />
/// <reference path="../../config/inertia.ts" />

import '../css/app.css';

import { createInertiaApp, type ResolvedComponent, page, router } from '@inertiajs/svelte'
import { get } from 'svelte/store'
import { resolvePageComponent } from '@adonisjs/inertia/helpers'
import { hydrate, mount } from 'svelte'
import { syncSiteCartFromServer } from '~/lib/site-cart-store.svelte'
import { readServerSiteCart } from '~/lib/site-cart-view'
import { fetchSiteCartSnapshot } from '~/lib/site-cart'

// Экспортируем router в window для использования в inline скриптах
if (typeof window !== 'undefined') {
  (window as any).$inertia = { router }
}

// Добавляем Telegram initData в каждый запрос (GET, POST, PUT, DELETE)
router.on('before', (event) => {
  const initData = localStorage.getItem('tg_init_data')
  if (initData) {
    event.detail.visit.headers = {
      ...event.detail.visit.headers,
      'X-Telegram-Init-Data': initData,
    }
  }
})

createInertiaApp({
  progress: { color: '#5468FF' },

  resolve: (name) => {
    return resolvePageComponent<ResolvedComponent>(
      `../pages/${name}.svelte`,
      import.meta.glob<ResolvedComponent>('../pages/**/*.svelte'),
    )
  },

  setup({ el, App, props }) {
    if (!el) throw new Error('Missing root element. Make sure to add a div#app to your page')

    const initialProps = (props.initialPage?.props ?? {}) as Record<string, unknown>
    syncSiteCartFromServer(readServerSiteCart(initialProps))

    router.on('finish', () => {
      const currentPage = get(page)
      if (!currentPage?.props) {
        return
      }
      const pageProps = currentPage.props as Record<string, unknown>
      syncSiteCartFromServer(readServerSiteCart(pageProps))
      void fetchSiteCartSnapshot(pageProps)
    })

    if (el.dataset.serverRendered === 'true') {
      hydrate(App, { target: el, props })
    } else {
      mount(App, { target: el, props })
    }
  },
})